export const eventShare = (title, text, url) => {
  const values = {
    title,
    text,
    url,
  };

  if (navigator.share) {
    try {
      navigator.share(values);
    } catch (error) {}
  }
};

const formatShareURL = url => {
  const separator = url.indexOf('?') === -1 ? '?' : '&';
  const ePar = 'epar=rs_00_pp_00_botaoshare';
  const formattedURL = `${url}${separator}${ePar}`;

  return formattedURL;
};

const formatTwitterText = text => {
  const limit = 253;
  return text.length > limit ? `${text.substring(0, limit - 2)}...` : text;
};

const getData = (label, url, title) => {
  const isTwitter = label === 'twitter';
  const text = isTwitter ? formatTwitterText(title) : title;

  return {
    title: text,
    url: formatShareURL(url),
  };
};

const getFacebookLink = url => `https://www.facebook.com/sharer/sharer.php?u=${url}`;
const getTwitterLink = (url, title) => `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
const getWhatsappLink = url => `https://web.whatsapp.com/send?text=${url}`;
const getPinterestLink = (url, title) => `http://pinterest.com/pin/create/button/?url=${url}&description=${title}`;

const getUrl = (label, dataUrl, dataTitle) => {
  const { url, title } = getData(label, dataUrl, dataTitle);
  const socialShareUrls = {
    facebook: getFacebookLink(url),
    twitter: getTwitterLink(url, title),
    whatsapp: getWhatsappLink(url),
    pinterest: getPinterestLink(url, title),
  };

  return socialShareUrls[label.replace(' ', '')];
};

export const openWindow = (label, url, title) => {
  const resultUrl = getUrl(label, url, title);

  return window.open(resultUrl, 'socialShare', 'top=200,left=500,width=700,height=550');
};
